import React from 'react';
import PropTypes from 'prop-types';

const FormField = ({
	type,
	action,
	keyPressAction = () => {},
	disabled = false,
	error = '',
	id,
	label = '',
	name = '',
	placeholder = '',
	required = false,
	value,
	fullWidth = false,
	maxLength = null,
	readOnly = false,
}) => (
	<>
		{label && (
			<label
				className="form-label"
				htmlFor={id}
			>
				{label}
				{required && <span className="font-color-theme-danger"> *</span>}
			</label>
		)}
		<div className={`form__container ${fullWidth ? 'is-full-width' : ''}`}>
			<input
				type={type}
				className={`form-field ${error ? 'error' : ''} ${fullWidth ? 'is-full-width' : ''}`}
				disabled={disabled}
				id={id}
				name={name}
				onChange={action}
				onKeyPress={keyPressAction}
				placeholder={placeholder}
				value={value}
				maxLength={maxLength || 524288}
				readOnly={readOnly}
			/>
		</div>
		{error && (
			<p className="font-color-theme-danger">
				{error}
			</p>
		)}
	</>
);

export default FormField;

FormField.propTypes = {
	type: PropTypes.oneOf([
		'text',
		'password',
		'email',
		'tel',
		'url',
		'search',
		'date',
		'time',
		'number',
		'color',
	]).isRequired,
	action: PropTypes.func.isRequired,
	keyPressAction: PropTypes.func,
	disabled: PropTypes.bool,
	error: PropTypes.string,
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	name: PropTypes.string,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	readOnly: PropTypes.bool,
	value: PropTypes.oneOfType(
		[PropTypes.string, PropTypes.number],
	).isRequired,
	fullWidth: PropTypes.bool,
	maxLength: PropTypes.number,
};
